import { formatRemove } from "@format-string/core";
import { useState } from "react";
import { useConfigPageContext } from "src/Contexts/configPagesContext/configPagesContext";
import { useLayoutMainContext } from "src/Contexts/MainLayoutContext";
import { useContextProdutor } from "src/Contexts/produtores/ProdutoresContext";
import { UseAutoCompletedAll } from "src/Contexts/Utils/UseAutoCompletedAll";
import { api } from "src/shared/setup/API/api";
import { apenasNumeros } from "src/shared/Utils/FormatMoney";

interface IUseFeaturesFormProducer {
  setOpenModal: React.Dispatch<React.SetStateAction<boolean>>;
}

export const UseFeaturesFormProducer = ({ setOpenModal }: IUseFeaturesFormProducer) => {
  const { valuesInputsProdutor } = useContextProdutor();
  const { handleGetAlert } = useLayoutMainContext();

  const [loading, setLoading] = useState(false);

  const {
    valueAutoCompletedFiliais,
    valueAutoCompGrupoImposto,
    valueAutoCompSupervisor,
    valueAutoCompGerente,
  } = UseAutoCompletedAll();

  const { setAttTable, id } = useConfigPageContext();

  const AllDatas = {
    ...valuesInputsProdutor,
    gerente: valueAutoCompGerente.id,
    supervisor: valueAutoCompSupervisor.id,
    id_filial: valueAutoCompletedFiliais.id,
    id_grupo_imposto: valueAutoCompGrupoImposto.id,
    cpf_cnpj: formatRemove(valuesInputsProdutor.cpf_cnpj),
    telefone1: formatRemove(valuesInputsProdutor.telefone1),
    telefone2: formatRemove(valuesInputsProdutor.telefone2),
    rg: formatRemove(valuesInputsProdutor.rg),

    cep: apenasNumeros(valuesInputsProdutor.cep),
  };

  const handleCreateProdutores = async () => {
    if (!valuesInputsProdutor.nome)
      return handleGetAlert({ message: `Digite um nome` });

    setLoading(true);

    return api
      .post("/produtores/create", AllDatas)
      .then((res) => {
        setAttTable((item) => !item);
        handleGetAlert({ message: res.data.message });
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleEditProdutores = () => {
    if (!valuesInputsProdutor.nome)
      return handleGetAlert({ message: `Digite um nome` });

    setLoading(true);

    return api
      .put(`/produtor/${id}`, AllDatas)
      .then((res) => {
        handleGetAlert({ message: res.data.message });
        setAttTable((item) => !item);
        setOpenModal(false);
      })
      .catch((error) =>
        handleGetAlert({ message: error.response.data.message })
      )
      .finally(() => setLoading(false));
  };

  const handleSubmit = () => {
    if (id) {
      handleEditProdutores();
    } else {
      handleCreateProdutores();
    }
  };

  return { handleSubmit, loading };
};
